module.exports = __webpack_public_path__ + "static/media/img-odoctorcash.32b0b432.jpg";